<template>
  <div>
    <signBatch v-if="isSignBatchSelected" :toggle-tab="toggleTab"></signBatch>
    <signBatchEfirma v-if="isSignBatchEfirmaSelected" :toggle-tab="toggleTab"></signBatchEfirma>
    <signBatchFirel v-if="isSignBatchFirelSelected" :toggle-tab="toggleTab"></signBatchFirel>
    <waiting v-if="isSuccess" :toggle-tab="toggleTab" :redirect-url="redirectUrl" />
    <DocumentNotAvailable v-if="isDocumentNotAvailable" :toggle-tab="toggleTab"/>
    <SignatureRejected v-if="isSignatureRejected" :toggle-tab="toggleTab"/>
    <SignedDocument v-if="isSignedDocument" :toggle-tab="toggleTab" :redirect-url="redirectUrl"/>
    <isSigningBatch v-if="isSigningBatch" :toggle-tab="toggleTab"/>
  </div>
</template>

<script>
import SignBatch from "@/views/pages/sign-document/components/SignBatch";
import SignBatchEfirma from "@/views/pages/sign-document/components/SignBatchEfirma";
import SignBatchFirel from "@/views/pages/sign-document/components/SignBatchFirel";
import Success from "@/views/pages/sign-document/components/Success";
import DocumentNotAvailable from "@/views/pages/sign-document/components/DocumentNotAvailable";
import SignatureRejected from "@/views/pages/sign-document/components/SignatureRejected";
import SignedDocument from "@/views/pages/sign-document/components/SignedDocument";
import isSigningBatch from "@/views/pages/sign-document/components/isSigningBatch";
import Waiting from "@/views/pages/sign-document/components/Waiting";

export default {
  name: "SignDocumentPage",
  components: {
    SignBatch,
    SignBatchEfirma,
    SignBatchFirel,
    isSigningBatch,
    Success,
    DocumentNotAvailable,
    SignatureRejected,
    SignedDocument,
    Waiting
  },
  data() {
    return {
      tabIndex: 1,
      redirectUrl: null,
    }
  },
  computed: {
    isSignBatchSelected() {
      return this.tabIndex === 1;
    },

    isSignBatchEfirmaSelected() {
      return this.tabIndex === 2;
    },

    isSuccess() {
      return this.tabIndex === 3;
    },

    isDocumentNotAvailable() {
      return this.tabIndex === 4;
    },

    isSignatureRejected() {
      return this.tabIndex === 5;
    },
    isSignedDocument() {
      return this.tabIndex === 6;
    },
    isSigningBatch() {
      return this.tabIndex === 7;
    },
    isSignBatchFirelSelected() {
      return this.tabIndex === 8;
    },
  },
  methods: {
    toggleTab(index, redirectUrl = null) {
      this.tabIndex = index;
      this.redirectUrl = redirectUrl;
    }
  }
}
</script>

<style scoped>

</style>
